import Layout from '@components/layout/Layout'
import SEO from '@components/seo'
import ScheduleTourSnippet from '@components/tempe/tempePage/ScheduleTourSnippet'
import React, {useCallback, useEffect, useState} from 'react'

const FloorPlansSnippet: React.FC = () => {
  const [domainUpdated, setDomainUpdated] = useState(false)
  useEffect(() => {
    const handleIframeMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://prospectportal.culdesac.com') return
      // identifyScript is a custom "source" for the js on the iframe
      if (event?.data?.source !== 'identifyScript') return

      const {userId, applicationId, email} = event.data.payload

      if (userId) {
        // Alias for Segment
        analytics?.alias(userId)
        if (typeof window != undefined) {
          // Identify for DataDog
          window.DD_RUM?.setUser({id: userId, ...(email ? {email} : {})})
        }
      }

      if (applicationId || email) {
        delete event.data.payload.userId
        analytics?.identify(userId, event.data.payload)
      }
    }

    window.addEventListener('message', handleIframeMessage)

    return () => {
      window.removeEventListener('message', handleIframeMessage)
    }
  }, [])

  const iframeRef = useCallback((node: HTMLIFrameElement) => {
    if (node !== null) {
      if (typeof window !== undefined) {
        ;(window as any).strSnippetDomain = (window as any).strSnippetDomain || []
        ;(window as any).strSnippetDomain.push('//prospectportal.culdesac.com')
      }
      node.src = node.src + 'host_domain=' + location.hostname
      setDomainUpdated(true)
    }
  }, [])

  const description = `Culdesac Tempe floor plans. See all of the floor plans for the first car-free neighborhood in the US. Culdesac Tempe (Phoenix) - 1000 people, 0 cars.`
  return (
    <>
      <SEO description={description} title="Tempe Floor Plans" />
      <Layout className="flex flex-col h-screen" showFooter={false} unmaskPageInDatadog>
        <section className="flex justify-center flex-grow px-2 md:px-6">
          <iframe
            allowTransparency={true}
            className="border-0"
            id="website_1279098"
            ref={iframeRef}
            src="//prospectportal.culdesac.com/tempe/culdesac-tempe/?&is_responsive_snippet=1&snippet_type=website&occupancy_type=1&locale_code=&is_collapsed=0&include_paragraph_content=1&"
            width="100%"
          />
          {domainUpdated && (
            <script
              src="//culdesac.prospectportal.com/javascript/iframe_cross_domain_script.js"
              type="text/javascript"
            />
          )}
        </section>
      </Layout>
      <ScheduleTourSnippet />
    </>
  )
}

export default FloorPlansSnippet
